import i18n from "@/shared/config/i18n";

export const DeviceStatus = Object.freeze({
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  BLOCKED: "BLOCKED",
});

export const DeviceStatusLabel = {
  [DeviceStatus.ACTIVE]: i18n.global.t("Активно"),
  [DeviceStatus.INACTIVE]: i18n.global.t("Неактивно"),
  [DeviceStatus.BLOCKED]: i18n.global.t("Заблокировано"),
};

export const DeviceStatusVariant = {
  [DeviceStatus.ACTIVE]: "success",
  [DeviceStatus.INACTIVE]: "default",
  [DeviceStatus.BLOCKED]: "danger",
};
